import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'linebreak'
})
export class LineBreakPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return value.replace(new RegExp('\n', 'g'), '<br>');
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/pipes/line-break.pipe.ts